import { render, staticRenderFns } from "./cookie-consent.vue?vue&type=template&id=5ff9aae1&"
import script from "./cookie-consent.vue?vue&type=script&lang=js&"
export * from "./cookie-consent.vue?vue&type=script&lang=js&"
import style0 from "./cookie-consent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports